import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc controller
     * @name ReportDetailsCtrl
     * @memberof app
     *
     * @description
     * Serving all report details in a centralized fashion using the {@link app.pkpAuctionDetails} directive
     * and information appending it in the template.
     *
     * @author flzemke.btc
     */
    angular.module('app').controller('ReportDetailsCtrl', ReportDetailsCtrl);

    function ReportDetailsCtrl(
        $routeParams,
        $location,
        $log,
        $anchorScroll,
        reportingService,
        platformSettingsService,
        Surrender,
        auctionResource,
        TradeProposals,
        SecondaryTrade,
        Fcfs,
        DATES,
        activitiesService,
        authService,
        fcfsBookingService
    ) {
        var vm = this;

        var reportTypeKey = $routeParams.reportType.toUpperCase();
        var report = reportingService.REPORT[reportTypeKey];

        vm.pages = {
            surrenderFcfsContractsDetails:
                'app/reporting-details/surrender-fcfs-contracts-details.html'
        };

        vm.DATES = DATES;
        vm.REPORT = reportingService.REPORT;
        vm.report = report;
        /** @type {boolean} */ vm.isLoggedIn = null;
        vm.loggedInUser = null;
        vm.uiLoading = true;
        vm.uiLoadingError = false;
        /**
         * BTCPKP-8071: There should not be a "Bidding rounds" section; that one is not foreseen for
         * reverse auctions as well as short term auctions
         * */
        vm.displayBiddingRoundsGraph = true;
        vm.headlineTitle = '';
        /**
         * The result for the user i.e. won or partially won.
         *
         * @type {*}
         */
        vm.result = null;
        vm.details = {};
        vm.auctionId = null;
        vm.auction = {};
        vm.rawDataId = null;
        vm.reportTypeKey = reportTypeKey;
        vm.isMultiCurrency = false;
        vm.isPdfExportAvailable = true;
        vm.isCsvExportAvailable = true;
        vm.hasRealizableCapacity = false;
        vm.pdfExportUrl = null;
        vm.csvExportUrl = null;
        vm.showCompetition = false;
        vm.myRequestedQuantity = myRequestedQuantity;
        vm.scrollTo = scrollTo;
        vm.hasUndiscountedOrder = false;
        vm.hasDiscountedOrder = false;

        (function init() {
            authService.userLoginPromise.promise
                .then((loggedInUser) => {
                    vm.isLoggedIn = !!loggedInUser;
                    vm.loggedInUser = loggedInUser;
                })
                .catch(() => {
                    vm.isLoggedIn = false;
                    vm.loggedInUser = null;
                });
        })();

        switch (report) {
            case reportingService.REPORT.AUCTION: {
                var isBuyBackAuction = $routeParams.reverse === 'true';
                if (isBuyBackAuction) {
                    vm.isCsvExportAvailable = false;
                }

                var param = {
                    auctionId: $routeParams.auctionId,
                    isBuyBackAuction: isBuyBackAuction
                };
                vm.headlineTitle = isBuyBackAuction
                    ? 'Reverse auction'
                    : 'Auction';

                auctionResource
                    .get(
                        param,
                        function (res) {
                            vm.auction = res;
                            vm.hasRealizableCapacity = res.realizableCapacity;
                            vm.displayBiddingRoundsGraph = !(
                                vm.auction.periodType === 'WITHINDAY' ||
                                vm.auction.periodType === 'DAY' ||
                                vm.auction.periodType === 'MULTIHOUR'
                            );
                            vm.auctionId = res.id;
                            vm.auctionRuntime = res.runtime;
                            if (vm.isLoggedIn && res.phase === 'FINISHED') {
                                vm.result = res.ordersState;
                            } else {
                                vm.result = res.phase;
                            }
                            vm.companyBids = res.orders;
                            vm.isMultiCurrency = res.multiCurrency;

                            if (res.algorithmType === 'LONG_TERM') {
                                vm.numberOfSteps =
                                    activitiesService.getSmallAndLargePriceSteps(
                                        res.auctionWindow
                                    );
                            }

                            vm.pdfExportUrl =
                                reportingService.mapExportUrls(report, 'PDF') +
                                '?id=' +
                                res.id;
                            vm.csvExportUrl =
                                reportingService.mapExportUrls(report, 'CSV') +
                                '?id=' +
                                res.id;

                            vm.hasUndiscountedOrder =
                                vm.companyBids &&
                                vm.companyBids.some((bid) => bid.undiscounted);
                            vm.hasDiscountedOrder =
                                vm.companyBids &&
                                vm.companyBids.some(
                                    (bid) =>
                                        bid.hasOwnProperty('undiscounted') &&
                                        !bid.undiscounted
                                );
                        },
                        onError
                    )
                    .$promise.finally(onFinally);

                break;
            }
            case reportingService.REPORT.FCFS: {
                Fcfs.getFcfsOrder(
                    { id: $routeParams.auctionId },
                    function (res) {
                        var contract = {
                            runtime: res.runtime,
                            capacityCategory0: res.capacityCategory0,
                            capacityCategory1: res.capacityCategory1,
                            networkPoint: res.networkPoint,
                            orderId: res.order.id
                        };

                        vm.auction = contract;
                        if (contract && !vm.auction.runtime) {
                            vm.auction.runtime = contract.runtime;
                        }
                        angular.extend(
                            vm.auction,
                            reportingService.mapCharges(
                                res.charges0,
                                res.charges1
                            )
                        );

                        vm.charges = [res.charges0];

                        if (res.networkPoint.bundled) {
                            vm.charges.push(res.charges1);
                        }

                        vm.details = res;
                        $log.info(res);
                        // adapt dealId and id to match with old platform
                        vm.details._id = vm.details.id;
                        vm.details._dealId = vm.details.dealId;
                        vm.details.dealId = vm.details.legalContractPositionId0;
                        vm.details.id = vm.details._dealId;
                        vm.result = res.status;
                        vm.auctionId = vm.details._dealId;

                        vm.pdfExportUrl =
                            reportingService.mapExportUrls(report, 'PDF') +
                            '?id=' +
                            vm.auction.orderId;
                        vm.isCsvExportAvailable = false;
                    },
                    onError
                ).$promise.finally(onFinally);
                vm.headlineTitle = 'Deal';
                vm.copyBooking = copyBooking;

                break;
            }
            case reportingService.REPORT.SURRENDER: {
                Surrender.getSurrender(
                    { id: $routeParams.auctionId },
                    function (res) {
                        vm.auction = res;
                        vm.auction.runtime = res.interval;
                        vm.auctionId = res.id;
                        vm.details = res;
                        vm.result = 'SUCCESFUL';
                        vm.isPdfExportAvailable = false;
                        vm.isCsvExportAvailable = false;
                    },
                    onError
                ).$promise.finally(onFinally);
                vm.headlineTitle = 'Surrender';
                break;
            }
            case reportingService.REPORT.CONTRACTS: {
                Fcfs.getLegalContractPosition(
                    { id: $routeParams.auctionId },
                    function (res) {
                        vm.auction = res;
                        vm.auction.runtime = res.interval;
                        vm.auctionId = res.id;
                        vm.details = res;
                        vm.charges = [res.charges];
                        vm.pdfExportUrl =
                            reportingService.mapExportUrls(report, 'PDF') +
                            '?id=' +
                            $routeParams.auctionId;
                        vm.isCsvExportAvailable = false;
                    },
                    onError
                ).$promise.finally(onFinally);
                vm.headlineTitle = 'Contract Position';
                break;
            }
            default: {
                $location.path('/start').search({});
            }
        }

        function copyBooking() {
            var data = {
                interval: vm.auction.runtime,
                capacity: vm.details.quantity,
                capacityCategory0: vm.auction.capacityCategory0,
                capacityCategory1: vm.auction.capacityCategory1,
                undiscounted:
                    vm.details.undiscounted0 || vm.details.undiscounted1
            };
            fcfsBookingService.reset();
            fcfsBookingService.setNetworkPoint(vm.auction.networkPoint);
            fcfsBookingService.setStageTwo(data);
        }

        function onError() {
            vm.uiLoadingError = true;
        }

        function onFinally() {
            vm.uiLoading = false;
        }

        function scrollTo(anchor) {
            var old = $location.hash();
            $location.hash(anchor);
            $anchorScroll();
            $location.hash(old);
        }

        function myRequestedQuantity(window) {
            return window.hasOwnProperty('myRequestedQuantity');
        }
    }
})();
